export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8851.f75ef173.jpg";